module.exports = __webpack_public_path__ + "static/media/quiz-4.7ca1e293.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/quiz-4.png
// module id = 131
// module chunks = 0